import { inch2cm } from "../insole-web-common/src/engine/parameters.js";
import { EnsureNumberOrNullish, GetNestedProperty, IsNotNullish, IsNullish } from "../util.js";
export function GetCurrentMetadataVersion() {
    return 5;
}
// TODO: Find a better name for this!
export function MetadataBackwardCompatibilityConversion(metadata, importedMeshCenterY) {
    /* TODO: Metadata version 4 holds the landmark positions with a different origin compared to earlier versions.
    Ideally metadata compatibility conversion is handled always when footscan was also imported and processed.
    Currently it's not easy to refactor the code to achieve this goal.
    importedMeshCenterY is an optional parameter and when it exists and metadata contains landmarks, the landmark conversion is done.
    However when it's not exist we need to do the conversion later. For this the footscanLandmarksBackwardCompatibilityConversionNeeded field
    was introduced to the internal metadata structure.
    However we always need to do the landmark conversion sometime before exporting the metadata otherwise the saved
    landmarks will not be compatible with the new version.
    */
    if (!metadata) {
        return;
    }
    const version = metadata.version;
    metadata.footscanLandmarksBackwardCompatibilityConversionNeeded = version < 4;
    if (version === GetCurrentMetadataVersion()) {
        return;
    }
    if (version < 3) {
        const archReinforcement = GetNestedProperty(metadata, "archReinforcement");
        if (IsNotNullish(archReinforcement)) {
            const widthScale = EnsureNumberOrNullish(GetNestedProperty(archReinforcement, "widthScale"));
            if (IsNotNullish(widthScale)) {
                archReinforcement.lateralStretch = widthScale;
                delete archReinforcement.widthScale;
            }
        }
        const hpSpecific = GetNestedProperty(metadata, "hpSpecific");
        if (IsNotNullish(hpSpecific)) {
            switch (hpSpecific.archModification) {
                case "increase":
                    hpSpecific.archModification = inch2cm / 8;
                    break;
                case "decrease":
                    hpSpecific.archModification = -inch2cm / 8;
                    break;
                default:
                    delete hpSpecific.archModification;
                    break;
            }
            switch (hpSpecific.widthModification) {
                case "wide":
                    hpSpecific.widthModification = inch2cm / 8;
                    break;
                case "extra-wide":
                    hpSpecific.widthModification = inch2cm / 4;
                    break;
                case "narrow":
                    hpSpecific.widthModification = -inch2cm / 8;
                    break;
                default:
                    delete hpSpecific.widthModification;
                    break;
            }
        }
    }
    if (version < 4 && IsNotNullish(importedMeshCenterY)) {
        FootscanMetadataBackwardCompatibilityConversion(metadata, importedMeshCenterY);
    }
    metadata.version = GetCurrentMetadataVersion();
}
export function FootscanMetadataBackwardCompatibilityConversion(metadata, importMeshCenterY) {
    if (!metadata.footscanLandmarksBackwardCompatibilityConversionNeeded ||
        IsNullish(metadata.footScanParameters) ||
        IsNullish(metadata.footScanParameters.landmarkPositions)) {
        return;
    }
    const { landmarkPositions } = metadata.footScanParameters;
    const updateLandmark = (position) => {
        if (IsNullish(position)) {
            return;
        }
        position.y += importMeshCenterY;
    };
    updateLandmark(landmarkPositions.mpj1);
    updateLandmark(landmarkPositions.mpj5);
    updateLandmark(landmarkPositions.boh);
    updateLandmark(landmarkPositions.mh);
    updateLandmark(landmarkPositions.lh);
    updateLandmark(landmarkPositions.arch);
    metadata.footscanLandmarksBackwardCompatibilityConversionNeeded = false;
}
//# sourceMappingURL=metadata-backwards-compatibility.js.map